// extracted by mini-css-extract-plugin
export default {"container":"Paragraph_container__CkhIy","content":"Paragraph_content__liiev"};